export enum HolidayServiceType {
  Redirect = "redirect",
  Break = "break",
  Download = "download",
}
